module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-02.fe1956d3.jpg";